export default "__VITE_ASSET__Bu$hCevD__"